module.exports = __webpack_public_path__ + "media/images/emblems/Molondin-coat_of_arms-d914c49b8433dc9bca8ce696a4584584.svg";